<template>
	<div class="content_main">
		<div style="margin-top: 10px">
			<a-button type="primary" @click="addcust">添加客服代表</a-button>
		</div>
		<div class="content_main_top">
			<a-input style="width: 200px; margin-right: 10px;" v-model="serchInfo.companyName" allowClear placeholder="参数名称"
				@keyup.enter.native="serch_get_lis" />
			<a-button type="primary" @click="serch_get_lis"> 查询 </a-button>
			<a-button type="primary" ghost @click="queryall"> 重置 </a-button>
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<a-table :data-source="lis" bordered :loading="loading" :pagination="pagination" @change="handleTableChange"
				:scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }">
				<a-table-column key="companyName" title="参数名称" ellipsis="true" data-index="companyName">
					<template scope="text,record">
						{{text}}客户代表
					</template>
				</a-table-column>
				<a-table-column key="companyName" title="公司" ellipsis="true" data-index="companyName" />
				<a-table-column key="department" title="部门" ellipsis="true" data-index="department" />
				<a-table-column key="name" title="姓名" ellipsis="true" data-index="name" />
				<a-table-column key="telephone" title="电话" ellipsis="true" data-index="telephone" />
				<a-table-column key="email" title="邮箱" ellipsis="true" data-index="email" />
				<a-table-column title="操作" width="180px">
					<template scope="text,record">
						<a @click="details(record)">详情</a>
						<a-divider type="vertical" />
						<a @click="edit(record)">编辑</a>
						<a-divider type="vertical" />
						<a @click="deleteRowData(record)">删除</a>
					</template>
				</a-table-column>
			</a-table>
		</div>
		<a-modal class="gufiiguy" title="新增客服代表" :visible="addUserVisible" @cancel="cancleForm" width="60%"  :maskClosable="false">
			<a-form-model :model="form" :rules="rules" ref="ruleForm" :label-col="{ span: 6 }"
				:wrapper-col="{ span: 18 }">
				<div class="title">
                    <span>基本信息</span>
                </div>
				<a-row>
					<a-col :span="8" >
						<a-form-model-item label="公司" prop="companyId" class="model_span_form"
				 :rules="{
                  required: true,
                  message: '请选择公司名称',
                  trigger: 'change',
                }">
							<a-select allowClear placeholder="请选择" v-model="form.companyId" @change="handlecompanyplan">
								<a-select-option :value="item.value" v-for="(item, index) in companylist" :key="index">
									{{ item.title }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="部门" prop="department" class="model_span_form"
				 :rules="{
                  required: true,
                  message: '请选择部门名称',
                  trigger: 'change',
                }">
							<a-tree-select allowClear :treeData="deptTree" placeholder="请选择" :disabled="!this.form.companyId" v-model="form.department"
							 @change="selectDepartment1">
							 	<!-- <a-select-option :value="item.key" v-for="(item, index) in deptTree" :key="index">
									{{ item.title }}
								</a-select-option> -->
							</a-tree-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8" >
						<a-form-model-item label="姓名" prop="name" class="model_span_form"
				 :rules="{
                  required: true,
                  message: '请选择部门名称',
                  trigger: 'change',
                }">
							<a-select allowClear placeholder="请选择" v-model="form.name" :disabled="!this.form.department" @change="getUserInfor">
						        <a-select-option :value="item.userId" v-for="(item, index) in users" :key="index">
							       {{ item.userName }}
						        </a-select-option>
					        </a-select>
							<!-- <a-input  v-model="form.name" allowClear placeholder="请输入"/> -->

							<!-- <a-select allowClear placeholder="请选择" v-model="form.companyId" @change="handlecompanyplan">
								<a-select-option :value="item.value" v-for="(item, index) in companylist" :key="index">
									{{ item.title }}
								</a-select-option>
							</a-select> -->
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8" >
					<a-form-model-item label="电话" prop="telephone" class="model_span_form"
				 :rules="{
                  required: true,
                  message: '请输入电话',
                  trigger: 'change',
                }">
						<a-input  oninput="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" v-model="form.telephone" allowClear placeholder="请输入"/>
					</a-form-model-item>
					</a-col>
					<a-col :span="8" >
					<a-form-model-item label="邮箱" prop="email" class="model_span_form"
			        :rules="[{
                        required: true,
                        message: '请输入邮箱',
                        trigger: 'change',
                   },
                  {
                        required: true,
                        message: '请输入正确的邮箱',
                        pattern: new RegExp(/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/),
                        trigger: 'change',
                    }]">
						<a-input v-model="form.email" allowClear placeholder="请输入"/>
					</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
			<template slot="footer">
				<a-button key="back" @click="cancleForm"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="addcustomerService"> 确定 </a-button>
			</template>
		</a-modal>

		<!-- 客服详情 -->

		<a-modal :title="types==1?'客服代表-编辑':'客服代表-详情'" :visible="allvisible" @cancel="cancel" width="50%"  :maskClosable="false">
			<template slot="footer" v-if="types==1">
				<a-button key="back" @click="cancel"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="getOkAll"> 保存 </a-button>
			</template>
			<template slot="footer" v-else>
				<a-button key="back" @click="allvisible = false"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="allvisible = false"> 确定 </a-button>
			</template>
			<a-form-model :model="allform" :rules="rules" ref="allForm" :label-col="{ span: 6 }"
				:wrapper-col="{ span: 18 }">
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="公司" v-if="types==1" prop="companyName" :rules="{
					  required: true,
					  message: '请输入公司',
					  trigger: 'change',
					}">
					<a-select allowClear placeholder="请选择" v-model="allform.companyName" @change="handlecompanyplan1"  disabled>
						<a-select-option :value="item.deptId" v-for="(item, index) in companyList" :key="index">
							{{ item.title }}
						</a-select-option>
					</a-select>
							<!-- <a-input v-model="allform.companyName" placeholder="公司" /> -->
						</a-form-model-item>
						<a-form-model-item label="公司" v-else>
							<span>{{allform.companyName}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="部门" v-if="types==1" prop="department" :rules="{
						  required: true,
						  message: '请输入部门',
						  trigger: 'change',
						}">
						<!-- :disabled="!this.allform.companyId"  :disabled="this.disabled"-->
						<a-tree-select allowClear :treeData="departList1" placeholder="请选择"  v-model="allform.department"
							 @change="selectDepartment1" >
							</a-tree-select>
							<!-- <a-input v-model="allform.department" placeholder="部门" /> -->
						</a-form-model-item>
						<a-form-model-item label="部门" v-else>
							<span>{{allform.department}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="姓名" v-if="types==1" prop="name" :rules="{
						  required: true,
						  message: '请输入姓名',
						  trigger: 'change',
						}">
							<!-- <a-input v-model="allform.name" placeholder="姓名" /> -->
							<a-select allowClear placeholder="请选择" v-model="allform.name" @change="getUserInfor" :disabled="this.disabled1">
						        <a-select-option :value="item.userId" v-for="(item, index) in users" :key="index">
							       {{ item.userName }}
						        </a-select-option>
					        </a-select>
						</a-form-model-item>
						<a-form-model-item label="姓名" v-else>
							<span>{{allform.name}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="电话" v-if="types==1" prop="telephone" :rules="{
						  required: true,
						  message: '请输入电话',
						  trigger: 'change',
						}">
							<a-input v-model="allform.telephone" oninput="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" placeholder="电话" />
						</a-form-model-item>
						<a-form-model-item label="电话" v-else>
							<span>{{allform.telephone}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12"><a-form-model-item label="邮箱" v-if="types==1" prop="email"    :rules="[{
                        required: true,
                        message: '请输入邮箱',
                        trigger: 'change',
                   },
                  {
                        required: true,
                        message: '请输入正确的邮箱',
                        pattern: new RegExp(/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/),
                        trigger: 'change',
                    }]">
							<a-input v-model="allform.email" placeholder="邮箱" />
						</a-form-model-item>
						<a-form-model-item label="邮箱" v-else>
							<span>{{allform.email}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	import {
		getDeptListEnable2,
		getUserList
	} from '@/api/system'
	import {
		getCustomerServiceInfo,
		customerService,
		customerService_details,
		customerService_put,
		addCustomerService,
		delete_customerService,
		usreInfo,
		getUsreInfo,
		getInDepts
	} from '@/api/Industry'	
	import {
		tree_all
	} from '@/api/purchase'



	import { defineComponent, ref } from 'vue'
	export default {
		data() {
			return {
				form: {
					companyId: '',
					companyName: '',
					department: '',
					name: '',
                    telephone: '',
                    email: '',
				},
				addUserVisible: false,
				serchInfo: {
					companyName: '',
				},
				lis: [],
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				scroll_y: 150,
				loading: false,
				allvisible: false,
				allform: {
					companyName: '',
					department: '',
				},
				types: '',
				addvisible: false,
				companylist: [],
				deptTree: [],
				deptlist2: [],
				companyList: [],
				departList: [],
				users: [],
				disabled: true,
				disabled1: true,
				departList1: []
			}
		},
		mounted() {
			tree_all().then(res=>{
				this.companylist=res.data[0]
			})
			this.get_list()
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				 console.log(max_h, 'max_h===========================')
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() - 120
					 console.log(this.scroll_y, 'scroll_y=====================')
				}, 1000)
			})
		},
		methods: {
			deleteRowData(row) {
            var _this = this
            this.$confirm({
                title: '是否确认删除?',
                onOk() {
                //   _this.deleteData(row)
				delete_customerService(row.id.toFixed()).then(res => {
					if(res.code == 200){
						_this.$message.success(res.msg)
				        _this.get_list()
					} else {
						_this.$message.error(res.msg)
					}
				})
                },
                onCancel() {
                    _this.$message.warning('你点击了取消')
                },
                // class: 'test',
            })
			},
			// deleteData(row) {
			// 	// console.log(row.id.toFixed(), 'row.id.toFixed()=======================')
			// 	delete_customerService(row.id.toFixed()).then(res => {
			// 		if(res,code == 200){
			// 			this.$message.success(res.msg)
			// 	        this.get_list()
			// 		} else {
			// 			this.$message.error(res.msg)
			// 		}


			// 	})
				// customerService_details(row.id).then(res => {
				// 	this.allform = res.data
				// })
				// this.allvisible = true

			// },
			selectDepartment(e) {

			},
			handlecompanyplan1(e) {
			this.disabled = false
			this.allform.department = ''
			this.allform.name = ''
			this.allform.telephone = ''
			this.allform.email = ''
			console.log(e,'e================')
			this.companyList.forEach(item => {
		    if(item.deptId == e) {
			 this.allform.companyName = item.title
						// this.departList = item.children
		  const list = item.children
		  console.log(item.children,'item.children================')
          this.departList.forEach( item3 => {
          item.value = item3.title
          item.title = item3.title
          if(item.children) {
             item3.children.forEach( item1 => {
                item1.value = item1.title
                item1.title = item1.title
                 item1.children.forEach( item2 => {
                item2.value = item2.title
                item2.title = item2.title
             })
             })
          }
        })   
       this.departList = list 
	   this.disabled = false
	   console.log(this.departList,'this.departList================')

					}
				})
				

			},
			show(res) {
				console.log(res, 121)
				if (res) {
					this.audit = true
					this.form = res
					getDeptListEnable2().then((res) => {
						const data = res.rows
						if (data.length > 0) {
							const min = Math.min(...data.map((m) => m.parentId))
							this.buildtree2(data, this.deptTree, this.form.companyId)
							console.log(this.deptTree, 'this.deptTree+++++++++++++++++++++++++++++')
						}
					})
				} else {
					this.form = {
						deptId: undefined,
						companyId: undefined
						}
					}
				},

			//新增客服的取消事件
			cancleForm() {
				this.$nextTick(() => {
                    this.$refs.ruleForm.resetFields()
                    this.addUserVisible = false
                })
			},
			//获取用户详细信息
			getUserInfor(e) {
				console.log(e, 'e=================')
				this.users.forEach(item => {
					if(item.userId == e) {
						console.log(item, 'item=================')
						this.allform.name = item.userName
						this.form.name = item.userName
						console.log(this.form.name, 'this.form.name=================')
						
					}
				})
				
				getUsreInfo(e).then(res => {
					this.allform.telephone = res.phonenumber
					this.allform.email = res.email
					
				// console.log(res.phonenumber,'res.phonenumber======================================')

				})


			},
			// selectDepartment2(e) {
			// 	console.log(e, 'e----------------------------')
			// 	this.disabled1 = false
			// 		this.departList.forEach(item => {
			// 			console.log(item, 'item---------------------------')
					
			// 			if(item.deptId == e) {
							
							
			// 				this.form.department = item.title
			// 				this.allform.department = item.title
			// 				console.log(this.allform.department, 'this.allform.department---------------------------')
							
			// 			}
			// 		})

			// },



			selectDepartment1(e) {
				// this.form.name = ''
				// this.allform.name = ''
				this.allform.name = ''
				this.allform.telephone = ''
				

				console.log(e, 'e1----------------------------')
				this.deptTree.forEach(item => {
					
					console.log(item, 'item----------------------------')
						if(item.value == e) {
							this.form.department = item.title
							this.allform.department = item.title
						}
					})
					this.departList1.forEach(item => {
					console.log(item, 'item----------------------------')
						if(item.deptId == e) {
								this.disabled1 = false
							
							this.form.department = item.title
							this.allform.department = item.title
							
						}
					})
					
				
				// 获取当前部门的人员信息
				getUserList({
					deptId: e
				}).then(res => {
					if(res.code == 200){
						this.users = res.rows
						console.log(this.users, 'this.users===================================')
					
					} else {
						this.$message.error(res.msg)
					}
				console.log(res,'res======================================')

				})
			},
			selectDepartment(e) {
				this.deptTree.forEach(item => {
						if(item.value == e) {
							this.allform.department = item.title
						}
						

					})
				this.$forceUpdate()
			},
			
			//新增客服
        addcustomerService(event) {

			this.companylist.forEach(item => {
				if(item.value == this.form.companyId){
					this.form.companyName = item.title
					// item.children.forEach(item => {
					// 	if(item.deptId == this.form.deptId) {
					// 		this.form.department = item.title
					// 	}

					// })
				}
				
			})

			console.log(this.companylist, 'this.companylist++++++++++++++++++++++++==')
				this.companylist.forEach(item => {
					// console.log(event, 'event+++++++++++++++++++++++++++++')
						// console.log(item, 'item++++++++++++++++++++++++==')
						// if (item.companyId == this.form.companyId) {
						// 	this.form.companyName = item.title
						// }
						
					})
					
                       var list = {}
                      var arr = this.form
                     for (var key in arr) {
                      list[key] = arr[key]
					 }

            this.$refs.ruleForm.validate((valid) => {
              addCustomerService(list).then((res) => {
				  console.log(list, 'this.form++++++++++++++++++++++++==')
                if (res.code == 200) {
				this.get_list()
				//   this.$refs.allForm.clearValidate()
                //   this.$refs.allForm.resetFields()
                  this.addUserVisible = false
				  this.form = {}
                  this.$message.success('保存成功')
                  this.show(this.record)
				//   刷新数据列表
				
                } else {
                  this.$message.error(res.msg)
                  return
                }
				// this.get_list()
              })
			})
         
      },
			buildtree2(list, arr, parentId) {
				list.forEach((item) => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId,
							value: item.deptId, // value是给modal的select用的，2者属性不一样
							title: item.deptName,
							scopedSlots: {
								title: 'title',
							},
							children: [],
						}
						this.buildtree2(list, child.children, item.deptId)
						if (child.children.length === 0) {
							delete child.children
						}
						arr.push(child)
					}
				})
			},
			handlecompanyplan(value) {
				// this.form = {}
				this.deptTree = []
				this.form.deptId = undefined
				this.allform.department = ''
				this.$nextTick(() => {
					getDeptListEnable2().then((res) => {
						const data = res.rows
						if (data.length > 0) {
							const min = Math.min(...data.map((m) => m.parentId))
							this.buildtree2(data, this.deptTree, this.form.companyId)
							this.buildtree2(data, this.deptTree, this.allform.companyId)
						}
						// console.log(this.deptTree,'this.deptTree+++++++++++++++++++++++++')
					})
				})
			},
			addcust() {
				this.form = []
				this.addUserVisible = true
				// 获取当前客服列表
			// 	getCustomerServiceInfo().then((res) => {
			// 		if (res.code == 200) {
			// 			console.log(res.data, 'res.data+++++++++++++++++++++++++')
			// 			}
			// })


			},
			//搜索
			serch_get_lis() {
				this.loading = true
				this.pagination.current = 1
				this.get_list()
			},
			//改变分页
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current
				this.pagination.pageSize = pagination.pageSize
				this.loading = true
				this.get_list()
			},
			//获取列表
			get_list() {
				customerService({
					pageNum: this.pagination.current,
					pageSize: this.pagination.pageSize,
					companyName: this.serchInfo.companyName
				}).then((res) => {
					if (res.code == 200) {
						this.lis = res.data


                        console.log(this.lis, 'this.lis+++++++++++++++++++++++++')


						const pagination = {
							...this.pagination
						}
						pagination.total = res.total
						this.pagination = pagination
					} else {
						this.$message.error(res.msg)
					}
					this.loading = false
				})
			},
			details(row) {
				customerService_details(row.id).then(res => {
					this.allform = res.data
				})
				this.allvisible = true
				this.types = 0
			},
			//获取公司数据
			getCompayList() {
				 tree_all().then(res => {
					if (res.code == 200) {
						console.log(res, 'res=========================')
						this.companyList = res.data[0]
						console.log(this.companyList, 'this.companyList=========================')
							} else {
								this.$message.error(res.msg)
							}
			})

			},
			edit(row) {
				this.getCompayList()
				this.companylist.forEach(item => {
					if(item.deptId == row.companyId) {
		               this.departList1 = item.children 




		               console.log( this.departList1, ' this.departList1======================')

		                }
				})
				console.log(this.companylist,'this.companylist==================================')
				customerService_details(row.id).then(res => {
					this.allform = res.data
				})
				this.allvisible = true
				this.types = 1
			},
			cancel() {
				this.disabled = true
                this.disabled1 = true
                this.allvisible = false


			},
			getOkAll() {
				this.$refs.allForm.validate((valid) => {
					this.companylist.forEach(item => {
				// if(item.deptId == this.allform.companyId){
				// 	this.allform.companyName = item.title
				// 	console.log(item1.title, 'item1.title----------------------------')

				// 	item.children.forEach(item1 => {
				// 		if(item1.deptId == this.allform.deptId) {
				// 			console.log(item1.title, 'item1.title----------------------------')

				// 			this.allform.department = item1.title
				// 		}
				// 		console.log(this.allform.department, 'this.allform.department----------------------------')

				// 	})
				// }
				 console.log(item, 'item++++++++++++++++++++++++==')
			})
					if (valid) {
						customerService_put(this.allform).then(res => {
							if (res.code == 200) {
								this.get_list()
								this.$message.success('编辑成功')
								this.allvisible = false
								// this.get_list()
							} else {
								this.$message.success(res.msg)
							}
						})
					}
				})
				this.disabled = true
				this.disabled1 = true

			},
			queryall() {
				this.serchInfo = {}
				//刷新数据
				this.get_list()
			},
		}
	}
</script>

<style lang="less" scoped>
.content_main {
  padding: 10px;
padding-bottom: 40px;
}
.content .columMargin {

	text-align: right !important
}

</style>
